import { FC } from "react";
import { SearchResult } from "./SearchMessage.styled";

interface Props {
  searchTerm: any;
  results: any;
  searchCatagory: any;
  loading: boolean;
  total: number;
}

const SearchMessage: FC<Props> = ({
  searchTerm,
  results,
  searchCatagory,
  loading,
  total,
}) => {
  if (loading) {
    return <SearchResult>loading</SearchResult>;
  }
  return (
    <>
      <div style={{ display: "flex" }}>
        <SearchResult>
          {loading
            ? "loading"
            : `${total} Results for "${searchTerm}" ${
                searchCatagory?.name !== undefined ? `in ${searchCatagory?.name}` : ""
              }`}
        </SearchResult>
      </div>
    </>
  );
};

export default SearchMessage;
